import { StateCreator } from 'zustand';

import { InboxAccountFilterStore } from './types';

export const createInboxAccountFilterSlice: StateCreator<
  InboxAccountFilterStore
> = (set) => ({
  selectedAccountIds: null,
  setSelectedAccountIds: (ids) => set({ selectedAccountIds: ids }),
  reset: () => set({ selectedAccountIds: null }),
});
